import React from 'react';

const Benefits = () => (
	<div className="container main">
		<h2>Utilidad y ventajas</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>¿Qué utilidad y ventajas ofrece el <em>Portal Global de Alertas</em> de la OCDE?</h4>
				<p>
					Para las <strong>autoridades gubernamentales</strong>, el Portal contribuye a mejorar y reforzar el intercambio de información acerca de las retiradas de productos en todo el mundo, de manera centralizada
					y tempestiva. Las autoridades pueden seguir la trayectoria de las nuevas tendencias, sobre todo mediante los <a href="https://globalrecalls.oecd.org/#/dashboard?lang=es">dashboards interactivos</a>, e identificar aquellos riesgos para los consumidores
					que puedan exigir la adopción de medidas en su propia jurisdicción. Puesto que las cadenas de suministro y fabricación son mundiales y las compras en línea efectuadas a comerciantes ubicados en el extranjero son cada vez frecuentes, cuando exista un problema de seguridad, será necesario llevar a cabo la retirada de los productos en múltiples jurisdicciones.
				</p>
				<p>
					El Portal utiliza una clasificación taxonómica común a todos los productos, lo que simplifica su integración con las bases de datos nacionales sobre retirada de productos de las diferentes
					autoridades. Además, los gobiernos, así como cualquier ciudadano, que deseen analizar los datos del Portal al detalle, pueden acceder a una <a href="https://globalrecalls.oecd.org/#/admin?lang=es">API de exportación</a>.
				</p>
				<p>
					Por lo que respecta a las <strong>empresas</strong>, en particular a los <strong>fabricantes</strong> de productos, el Portal les proporciona información que les permitirá actuar con mayor
					rapidez en caso de verificarse un problema de seguridad, lo que reducirá el número de incidentes, lesiones y los costes que se derivan de ellos. <strong>Las empresas que importan productos de consumo del extranjero
					también se beneficiarán de la posibilidad de comprobar el estado de la retirada de productos en otras jurisdicciones</strong>. Gracias a la información disponible en el Portal, los <strong>minoristas y las plataformas en línea</strong> también podrán actuar tempestivamente y adoptar las medidas necesarias para retirar de la venta los productos inseguros.
				</p>
				<p>Para aquellos <strong>consumidores</strong> que estén interesados en comparar productos, el Portal, que cuenta con una versión para móviles, también ofrece una forma sencilla de comprobar el estado de retirada de un producto en cualquier lugar.</p>
			</div>
		</div>
	</div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/views/static/es/benefits.js